import { qsRequired } from '@/scripts/core/global'
import { ProductFormGeneric } from '@/scripts/product-form-context/ProductFormGeneric'

export class ProductFormStep extends ProductFormGeneric {
	static htmlSelector = 'product-form-step'
	submitButton: HTMLButtonElement

	constructor() {
		super()
		this.submitButton = qsRequired<HTMLButtonElement>('button', this)
		this.submitButton.addEventListener('click', this.onClick.bind(this))
	}
	onClick() {
		this.getContext().stepsCompleted++
		const productFormSteps = this.getContext()?.productFormSteps
		this.classList.remove('active')

		if (productFormSteps && this.getContext().stepsCompleted < productFormSteps.length) {
			const nextStep = productFormSteps[this.getContext().stepsCompleted]
			nextStep.classList.add('active')
		} else {
			this.getContext().groups[0].productForm.submitButton.click()
		}
	}
}
